export default "__VITE_ASSET__CYBZjQCy__"